import React from 'react';
import Header from './../Common/Header';
import Footer from './../Common/Footer';

var img1 = require('./../../images/left-men.png');
var img2 = require('./../../images/background/bg-4.png');
class Register extends React.Component {
    render() {
        return (
            <>

                <Header />
              
                <div className="section-full mobile-page-padding mission-outer-section  p-t80 p-b30 bg-gray bg-no-repeat bg-right-center" style={{ backgroundImage: 'url(' + img1 + '), url(' + img2 + ')' }}>
                <div className="section-full p-tb80 inner-page-padding">
                        {/* LOCATION BLOCK*/}
                        <div className="container">
                            {/* GOOGLE MAP & CONTACT FORM */}
                            <div className="section-content">
                                {/* CONTACT FORM*/}
                                <div className="row">
                                    <div className="col-md-8 col-sm-6">
                                        <form className="contact-form cons-contact-form" >
                                            <div className="contact-one m-b30">
                                                {/* TITLE START */}
                                                <div className="section-head">
                                                    <div className="mt-separator-outer separator-center">
                                                        <div className="mt-separator">
                                                            <h2 className="text-uppercase sep-line-one "><span className="font-weight-300 text-primary">Sign</span>up</h2>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* TITLE END */}
                                                <div className="form-group">
                                                    <input name="username" type="text" required className="form-control" placeholder="User Name" />
                                                </div>
                                                <div className="form-group">
                                                    <input name="email" type="text" required className="form-control" placeholder="Email" />
                                                </div>
                                                <div className="form-group">
                                                    <input name="password" type="password" className="form-control" required placeholder="Password" />
                                                </div>
                                                <div className="form-group">
                                                    <input name="confirmpassword" type="confirmpassword" className="form-control" required placeholder="Confirm Password" />
                                                </div>
                                                <div>
                                                    <p>Already have an account? <a className='font-weight-600 text-primary' href="/login">Login</a></p>
                                                </div>
                                                <div className="text-right">
                                                    <button name="signup" type="signup" value="Signup" className="site-button btn-effect">Sign up
                  </button>
                                                </div>
                                           
                                            </div>
                                        </form>
                                    </div>
                                   
                                </div>
                            </div>
                        </div>
                    </div>
        </div>
                <Footer />

            </>
        );
    };
};

export default Register;